import classNames from 'classnames'
import type { FunctionalComponent, HTMLAttributes } from 'vue'
import './index.layout.scss'

type LayoutProps = HTMLAttributes & {
  hiddenMarginBottom?: boolean
}

export const IndexLayout: FunctionalComponent<LayoutProps> = (props, { slots, attrs }) => {
  return (
    <div
      {...attrs}
      class={classNames('back-navigator-layout', { 'hidden-margin-bottom': props.hiddenMarginBottom }, attrs.class as string)}
    >
      {slots.default?.()}
    </div>
  )
}
IndexLayout.inheritAttrs = false

export default IndexLayout
